import React, { useEffect, useMemo } from 'react';

import createDatabaseManager from '@dyl/utils/createDatabaseManager';
import { CircularProgress } from '@mui/material';

const Levels = [
    { level_id: '8513d925-5a83-4944-8bf7-d72825245ac7', label: 'Pre-A1' },
    { level_id: 'a180c4cf-5c07-4254-8c86-bd40ddaab7c6', label: 'A1' },
    { level_id: '200f307f-415d-4bbc-9051-1568d16f96b8', label: 'A2' }
];

const { Provider: LevelsManager, use: useRaw } = createDatabaseManager({
    requestFunc: (args) => {
        return {
            levels: Levels,
            selected: Levels[0]
        };
    },
    defaultValue: { levels: Levels, selected: Levels[0] },
    contextName: 'LevelsManager',
    initialStatus: 'complete'
});

export default LevelsManager;

export function useLevels() {
    const {
        data,
        refresh: refreshLevels,
        status: levelsStatus,
        update
    } = useRaw();

    // On mount (only), load levels if unavailable
    useEffect(() => {
        if (levelsStatus === 'not started' || levelsStatus === 'error') {
            refreshLevels();
        }
    }, []);

    return {
        levels: data.levels,
        refreshLevels,
        levelsStatus,
        globalLevel: data.selected,
        setGlobalLevel: (value) => update({ data: { selected: value }})
    };
}

/**
 * Renders either the label for the level with the given ID,
 *  or a progress indicator if levels are loading.
 * @param {Object} props
 * @param {string} props.levelId
 */
export function LevelText({ levelId }) {
    const { levels, levelsStatus, globalLevel } = useLevels();

    return useMemo(() => {
        if (levelsStatus !== 'complete') {
            return <CircularProgress size='1em' />;
        }

        return (
            levels.find(l => l.level_id === levelId)?.label
            ?? globalLevel.label
        );
    }, [levelsStatus, levelId, levels, globalLevel]);
}